// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ttS6","header":"PatientQuestionnaire_header__2qb6f","info":"PatientQuestionnaire_info__27uCM"};